<template>
  <div class="clearfix videoList">
      <div class="mainVIdeo" v-if="fileList.length>0" v-for="(item,index) in fileList" :key="index">
            <div class="videoDiv"><video @click="goPage(item)" :src="item.url" width="104" height="104"></video></div>
      </div>  
      <a-upload
        :customRequest="customRequest"
        list-type="picture-card"
        :file-list="fileList"
        :remove="removeFile"
        :before-upload="beforeUpload"
        :disabled="disableBool"
      >   
          <a-icon :type="loading ? 'loading' : 'plus'" />
          <div class="ant-upload-text">上传</div>
      </a-upload>
  </div>
</template>

<script>
export default {
   data(){
     return{
        loading:false,
     }
   },
   props:{
      fileList:{
          type:Array
      },
      disableBool:{
          type:Boolean,
          default:false
      }
   },
   methods:{
      customRequest(info){
          let formdata=new FormData();
          formdata.append("file",info.file);
          this.loading = true;
          this.$https.post('/file/upload',formdata).then(res=>{
             this.loading = false;
             if(res.code == 200){
                  let obj = {
                      uid: info.file.uid,
                      name: res.data.name,
                      status: 'done',
                      url:res.data.url,
                  }
                  this.fileList.push(obj);
                  this.$emit('getFile',this.fileList)
             }
          }).catch(error=>{
            this.loading = false;
             this.$error({content:'上传失败'});
          })
      },
      removeFile(file){
           let arr = [];
           this.fileList.forEach(item=>{
              if(item.url != file.url){
                  arr.push(item)
              }
           })
           this.$emit('changeFile',arr)
      },
      handleChange(info){
        console.log(info)
          let obj = {};
              obj.uid = info.file.uid;
              obj.name = info.file.name;
              obj.status = info.status;
              // obj.url = info.
      },

      beforeUpload(file) {
        const isVideo =
          file.type === "video/mp4" || file.type === "video/flv" || file.type === "video/wmv" || file.type === "video/rmvb" || file.type === "video/mov";
        if (!isVideo) {
           this.$message.error('请上传视频格式')
         }
        // const isLt2M = file.size / 1024 / 1024 < 2;
        // if (!isLt2M) {
        //   const h = this.$createElement;
        //         this.$error({
        //             content: (<div><p>图片大小需小于 2MB!</p></div>),
        //         });
        // }
        return isVideo;
      },
      goPage(item){
        window.open(item.url);
      }
   }
}
</script>

<style lange="less" scoped>
.clearfix{
  display: flex;
}
.videoDiv{
  width: 104px;
  height: 104px;
  float:left;
  margin-right:10px;
  border: 1px solid #d9d9d9;
  cursor: pointer;
}
.ant-upload-list{
  display: none!important;
}

</style>